import * as pdfjsLib from 'pdfjs-dist';

// Worker URL'sini ayarla - CDN kullan
if (pdfjsLib.GlobalWorkerOptions) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;
}

// PDF.js'yi dışa aktar
export default pdfjsLib;